<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import unsafeReportAPI from "@/services/standards/communication/unsafeReportAPI.js";
import Swal from "sweetalert2";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Mecanismo de comunicación, auto reporte del SG SST",
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "2.8.1 Mecanismo de comunicación, auto reporte del SG SST ",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Mecanismo de comunicación, auto reporte del SG SST",
          active: true,
        },
      ],

      evidence: {
        condition: null,
        file: null,
        type_document_cm_id: 1,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      company: this.$store.getters["company/getCompany"] || null,

      loading: true,

      item: null,
      itemStatus: null,

      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      file: null,
      submitted: false,
      selected: '',
      usersList: [],

    };
  },
  methods: {
    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.evidence.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.8.1/Evidencia_comunicaciones/${this.$route.params.id}/${this.evidence.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/2.8.1/Evidencia_comunicaciones/${this.$route.params.id}/${this.evidence.employee_id}/${name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.evidence.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getEvidencia() {
      unsafeReportAPI.getEvidence(this.$route.params.id).then((response) => {
        this.evidence = {
          contact: response.contact,
          file: response.file,
          companies_id: response.companies_id,
          employee_id: response.employee_id,
          type_document_cm_id: response.type_document_cm_id,
        };
      })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        unsafeReportAPI.updateEvidence(this.$route.params.id, {
          contact: this.evidence.contact,
          file: this.evidence.file,
          companies_id: this.evidence.companies_id,
          employee_id: this.evidence.employee_id,
          type_document_cm_id: this.evidence.type_document_cm_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 19,
              status: itemStatus,
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          });
      } else {
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

  },
  mounted() {
    this.getUsers()
    this.getEvidencia()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">

      <div class="col-md-12">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select class="form-control" v-model="evidence.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Elemento que se comunico" label-for="date_exam">
                    <b-form-input type="text" id="elemento" v-model="evidence.contact">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir archivo de envidencia de comunicación"
                    label-for="file">
                    <b-form-file type="file" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="evidence.file ? getFile(evidence.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary ">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>
